export const NUMBEROFTRIES = 20
export const UI_DELAY_TO_SHOW_LOADING = 750
export const PLACCOUNTNAME = 'P&L'
export const NOSTRO_WASH_ACCOUNTNAME = 'Nostro wash'
